// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import NowPlayingMobileApp from 'components/NowPlaying/NowPlayingMobileApp'

class NowPlayingMobile extends React.Component {
	render() {
		return (
			<div className="mobile-now-playing">
				<NowPlayingMobileApp regularMobile={ true } />
			</div>
		)
	}
}


const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps )( NowPlayingMobile )
